import { Sun, Moon } from 'lucide-react';
import { motion } from 'framer-motion';
import { useThemeMode } from '../../../helpers/themeMode';

const ThemeToggle = () => {
  const { effectiveTheme, switchToDarkMode, switchToLightMode } = useThemeMode();
  const dark = effectiveTheme === 'dark';

  const handleToggle = () => {
    if (dark) {
      switchToLightMode();
      return;
    }
    switchToDarkMode();
  };

  return (
    <button
      onClick={handleToggle}
      className="relative flex h-8 w-8 items-center justify-center rounded-lg border border-border bg-card text-muted-foreground transition-colors hover:border-primary/40 hover:text-foreground"
      aria-label="Toggle theme"
    >
      <motion.div
        key={dark ? 'moon' : 'sun'}
        initial={{ scale: 0, rotate: -90 }}
        animate={{ scale: 1, rotate: 0 }}
        exit={{ scale: 0, rotate: 90 }}
        transition={{ duration: 0.2 }}
      >
        {dark ? <Sun size={16} /> : <Moon size={16} />}
      </motion.div>
    </button>
  );
};

export default ThemeToggle;
